import type { SnackbarCloseReason } from '@mui/material';
import type { FC, SyntheticEvent } from 'react';
import React from 'react';

import {
  closeSnackbar,
  selectNotification,
} from 'reduxStore/features/notifications/notificationsSlice';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';

import SnackbarNotification from './SnackbarNotification';

const SnackbarNotificationContainer: FC = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const notification = useAppSelector(selectNotification);

  const handleClose = (
    _event: SyntheticEvent<Element, Event> | Event,
    _reason?: SnackbarCloseReason
  ): void => {
    dispatch(closeSnackbar());
  };

  return (
    <SnackbarNotification
      errorDetails={notification.errorDetails}
      errorSource={notification.errorSource}
      message={notification.snackbarMessage}
      onClose={handleClose}
      open={notification.isOpen}
      severity={notification.snackBarSeverity}
      subMessage={notification.snackbarSubMessage}
    />
  );
};

export default SnackbarNotificationContainer;
